// Centralized Formstack quote links - REV 2
// All quote CTAs across the site should reference this file

export const QUOTE_LINKS = {
  // Auto Insurance
  auto: 'https://jfi.formstack.com/forms/auto_insurance_icbc_electronic_consent',
  
  // Home Insurance
  home: {
    homeowners: 'https://jfi.formstack.com/forms/home_principal_residence',
    condo: 'https://jfi.formstack.com/forms/condo_principal_residence',
    tenants: 'https://jfi.formstack.com/forms/renters_insurance',
    landlordHouse: 'https://jfi.formstack.com/forms/home_rental_property',
    landlordCondo: 'https://jfi.formstack.com/forms/condo_rented_to_others',
    strata: 'https://jfi.formstack.com/forms/residential_strata',
    newConstruction: 'https://jfi.formstack.com/forms/home_new_construction',
    seasonalDwelling: 'https://jfi.formstack.com/forms/home_seasonal_residence',
    vacantDwelling: 'https://jfi.formstack.com/forms/vacant_dwelling',
    vacantLand: 'https://jfi.formstack.com/forms/vacant_land'
  },
  
  // Business Insurance - Direct Formstack
  business: {
    businessProperty: 'https://jfi.formstack.com/forms/businessproperty',
    commercialLiability: 'https://jfi.formstack.com/forms/businessliability',
    generalContractors: 'https://jfi.formstack.com/forms/gc',
    // Painting Contractors: destination is a SINGLE swappable value.
    // null => "Talk to Us" in the modal. To switch to a form later, set this to
    // the Formstack URL — no other code changes needed.
    paintingContractors: 'https://jfi.formstack.com/forms/painting_contractors',
    commercialStrata: 'https://jfi.formstack.com/forms/cru',
    electricalContractors: 'https://jfi.formstack.com/forms/electricians',
    plumbingHeating: 'https://jfi.formstack.com/forms/plumbing',
    roofingContractors: 'https://jfi.formstack.com/forms/roofing',
    janitorialCleaning: 'https://jfi.formstack.com/forms/janitorial',
    farm: 'https://jfi.formstack.com/forms/farm',
    // Talk-to-us (no direct form)
    cyber: null,
    errorsOmissions: null,
    directorsOfficers: null
  },
  
  // Life & Benefits
  life: {
    lifeInsurance: 'https://jfi.formstack.com/forms/life_insurance',
    groupBenefits: 'https://jfi.formstack.com/forms/group_benefits'
  },
  
  // Travel Insurance - No forms, talk-to-us only
  travel: null,
  
  // Marine Insurance
  marine: {
    boatInsurance: 'https://jfi.formstack.com/forms/boat_insurance'
  }
};

// Slug to Formstack URL mapping for service pages
export const SERVICE_FORMSTACK_MAP = {
  // Auto - Hub opens modal, only ICBC Renewal has direct form
  'auto-insurance': null, // Opens modal with auto sub-options
  'icbc-renewal': QUOTE_LINKS.auto, // Only ICBC Renewal redirects to form
  'replacement-cost': null, // Talk-to-Us
  'fleet': null, // Talk-to-Us
  'motorcycle': null, // Talk-to-Us
  'new-to-bc': null, // Talk-to-Us
  
  // Home
  'home-insurance': null, // Opens modal
  'homeowners': QUOTE_LINKS.home.homeowners,
  'condo': QUOTE_LINKS.home.condo,
  'tenants': QUOTE_LINKS.home.tenants,
  'landlord-house': QUOTE_LINKS.home.landlordHouse,
  'landlord-condo': QUOTE_LINKS.home.landlordCondo,
  'strata': QUOTE_LINKS.home.strata,
  'new-construction': QUOTE_LINKS.home.newConstruction,
  'seasonal-dwelling': QUOTE_LINKS.home.seasonalDwelling,
  'vacant-dwelling': QUOTE_LINKS.home.vacantDwelling,
  'vacant-land': QUOTE_LINKS.home.vacantLand,
  
  // Business
  'business-insurance': null, // Opens modal
  'business-property': QUOTE_LINKS.business.businessProperty,
  'commercial-general-liability': QUOTE_LINKS.business.commercialLiability,
  'general-contractors': QUOTE_LINKS.business.generalContractors,
  'painting-contractors': QUOTE_LINKS.business.paintingContractors, // null => Talk to Us (swap in quoteLinks to a URL later)
  'commercial-strata': QUOTE_LINKS.business.commercialStrata,
  'electrical-contractors': QUOTE_LINKS.business.electricalContractors,
  'plumbing-heating': QUOTE_LINKS.business.plumbingHeating,
  'roofing-contractors': QUOTE_LINKS.business.roofingContractors,
  'janitorial-cleaning': QUOTE_LINKS.business.janitorialCleaning,
  'farm': QUOTE_LINKS.business.farm,
  'cyber': null, // Talk to us
  'errors-omissions': null, // Talk to us
  'directors-officers': null, // Talk to us
  
  // Life & Benefits
  'life-insurance': null, // Opens modal
  'life': QUOTE_LINKS.life.lifeInsurance,
  'term': QUOTE_LINKS.life.lifeInsurance,
  'whole-life': QUOTE_LINKS.life.lifeInsurance,
  'critical-illness': QUOTE_LINKS.life.lifeInsurance,
  'disability': QUOTE_LINKS.life.lifeInsurance,
  'group-benefits': null, // Opens modal
  'group-plans': QUOTE_LINKS.life.groupBenefits,
  'small-business': QUOTE_LINKS.life.groupBenefits,
  
  // Travel - All talk to us
  'travel-insurance': null,
  'emergency-medical': null,
  'visitors-to-canada': null,
  'super-visa': null,
  'student': null,
  'trip-cancellation': null,
  'multi-trip': null,
  
  // Marine
  'marine-insurance': null, // Opens modal
  'boat-insurance': QUOTE_LINKS.marine.boatInsurance,
  'sailboat': QUOTE_LINKS.marine.boatInsurance,
  'jet-ski': QUOTE_LINKS.marine.boatInsurance,
  'liability': QUOTE_LINKS.marine.boatInsurance,
  'seasonal': QUOTE_LINKS.marine.boatInsurance
};

// Get Formstack URL for a service slug
export const getFormstackUrl = (slug) => {
  return SERVICE_FORMSTACK_MAP[slug] || null;
};

export default QUOTE_LINKS;
